import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* collectiveInvoiceCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.COLLECTIVE_INVOICE_CREATE_REQUEST
    });

    const res = yield call(Http.post, `collective-invoice`, {
      ...action.payload
    });

    yield put({
      type: Constants.COLLECTIVE_INVOICE_CREATE_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data?.data?.url);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.COLLECTIVE_INVOICE_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchCollectiveInvoiceCreate() {
  yield takeEvery(Constants.COLLECTIVE_INVOICE_CREATE_START, collectiveInvoiceCreate);
}
